import { Directive, ElementRef, HostListener, OnInit, inject } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

/**
 * Conditionally shows a PrimeNG tooltip on the host element only when its text
 * content is truncated (scrollWidth > clientWidth). The `appEllipsisTooltip`
 * input is forwarded to the underlying `pTooltip` directive via hostDirectives,
 * so styling matches the rest of the app (cobalt-prime theme).
 */
@Directive({
  selector: '[appEllipsisTooltip]',
  standalone: false,
  hostDirectives: [
    {
      directive: Tooltip,
      inputs: ['pTooltip: appEllipsisTooltip', 'tooltipPosition'],
    },
  ],
})
export class EllipsisTooltipDirective implements OnInit {
  private readonly tooltip = inject(Tooltip);
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  ngOnInit(): void {
    this.tooltip.setOption({ tooltipPosition: 'top', disabled: true });
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const host = this.el.nativeElement;
    if (host.scrollWidth > host.clientWidth) {
      this.tooltip.setOption({ disabled: false });
      this.tooltip.activate();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.tooltip.deactivate();
    this.tooltip.setOption({ disabled: true });
  }
}
